import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { getBaseStyle, defaultContext, getInitialStyle, getSelectedStyle } from './radio.style';

export class Radio extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Border: {},
        Dot: {},
        Label: {},
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._style = defaultContext;
    this._isSelected = false;
  }

  get label() {
    return this.tag('Label').text.text;
  }

  set label(value) {
    this.tag('Label').text.text = value;
  }

  get isSelected() {
    return this._isSelected;
  }

  set isSelected(value) {
    const newValue = Boolean(value);
    if (this._isSelected !== newValue) {
      this._isSelected = newValue;
      this.patch(this._isSelected ? getSelectedStyle(this._style) : getBaseStyle(this._style));
    }
  }
}
